export default __webpack_public_path__ + "static/media/cert-general-staff-HKIRC-sc.06ecd081.jpg";